import { render, staticRenderFns } from "./MyCalendar.vue?vue&type=template&id=1a0ed1fb&scoped=true&"
import script from "./MyCalendar.vue?vue&type=script&lang=ts&"
export * from "./MyCalendar.vue?vue&type=script&lang=ts&"
import style0 from "./MyCalendar.vue?vue&type=style&index=0&id=1a0ed1fb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0ed1fb",
  null
  
)

export default component.exports